import { useState } from 'react';

import GenericPropertyInput from '../../../FlowDesigner/Components/Inputs/GenericPropertyInput';
import { TableColumnModel } from '../../Models/TableColumnModel';
import TableColumnsInputContent from './TableColumnsInputContent';
import { TableColumnsInputDialog } from './TableColumnsInputDialog';

type TableColumnsInputProps = {
	columns: TableColumnModel[] | undefined;
	onColumnsChange: (columns: TableColumnModel[] | undefined) => void;
};

export default function TableColumnsInput({ columns, onColumnsChange }: TableColumnsInputProps) {
	const [open, setOpen] = useState(false);

	return (
		<GenericPropertyInput value={columns} onValueChange={onColumnsChange} onOpen={() => setOpen(true)}>
			<TableColumnsInputContent value={columns} />
			{open && <TableColumnsInputDialog open={open} setOpen={setOpen} columns={columns} onColumnsChange={onColumnsChange} />}
		</GenericPropertyInput>
	);
}
